module.exports = __webpack_public_path__ + "assets/img/times.a18fd73b.svg";